export default "__VITE_ASSET__7decd8e7__"